import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'


const initialState = {
    loadBelegAusgabeStatus: 'idle',
    loadBelegAusgabeError: undefined as any,
    startBelegAusgabeStatus: 'idle',
    startBelegAusgabeError: undefined as any,

    belegAusgabeList: [] as any[],
    defaultValues: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}
export const loadBelegAusgabe = createAsyncThunk('belegAusgabeSlice/loadBelegAusgabe', async (parentModel: any, { rejectWithValue }: any) => {
    const url = `/api/ixweb/LoadUserParamsReport201051/`


    const res = await client.get(
        url,
        {
        })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})
export const startBelegAusgabe = createAsyncThunk('belegAusgabeSlice/startBelegAusgabe', async (belegAusgabe: any, { rejectWithValue }: any) => {
    const url = `/api/ixweb/StartReport201051/`


    const res = await client.post(url, prepareData(belegAusgabe))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { job_id: res.data.job_id }
        }
    } else {  // backend response
        return res.data
    }
})

const BelegAusgabeSlice = createSlice({
    name: 'belegAusgabeSlice',
    initialState,
    reducers: {
        resetloadBelegAusgabe: (state) => {
            state.defaultValues = undefined
            state.loadBelegAusgabeError = undefined
        },
        resetloadBelegAusgabeError: (state) => {
            state.loadBelegAusgabeError = undefined
        },
        resetstartBelegAusgabeError: (state) => {
            state.startBelegAusgabeError = undefined
        },
        removeFromBelegAusgabeListById: (state, action) => {
            state.belegAusgabeList = state.belegAusgabeList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        }
    },
    extraReducers: builder => {
        builder.addCase(loadBelegAusgabe.pending, (state) => {
            state.loadBelegAusgabeStatus = 'pending'
            state.loadBelegAusgabeError = undefined
        })
        builder.addCase(loadBelegAusgabe.fulfilled, (state, action) => {
            state.loadBelegAusgabeStatus = 'idle'


            state.defaultValues = action.payload
        })
        builder.addCase(loadBelegAusgabe.rejected, (state, action) => {
            state.loadBelegAusgabeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBelegAusgabeError = action.error.message
            } else {
                state.loadBelegAusgabeError = action.payload
            }
        })

        builder.addCase(startBelegAusgabe.pending, (state) => {
            state.startBelegAusgabeStatus = 'pending'
            state.startBelegAusgabeError = undefined
        })
        builder.addCase(startBelegAusgabe.fulfilled, (state, action) => {
            state.startBelegAusgabeStatus = 'idle'


            const i = state.belegAusgabeList.findIndex((x: any) => x.HDR_ID === action.payload.HDR_ID)
            if (i === -1) { state.belegAusgabeList.push(action.payload) }
            else { state.belegAusgabeList[i] = { ...state.belegAusgabeList[i], ...action.payload } }
        })
        builder.addCase(startBelegAusgabe.rejected, (state, action) => {
            state.startBelegAusgabeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startBelegAusgabeError = action.error.message
            } else {
                state.startBelegAusgabeError = action.payload
            }
        })

    }
})

export const {
    resetloadBelegAusgabe,
    resetloadBelegAusgabeError,
    resetstartBelegAusgabeError,
    removeFromBelegAusgabeListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB
} = BelegAusgabeSlice.actions
export default BelegAusgabeSlice.reducer
